// extracted by mini-css-extract-plugin
module.exports = {"counterpart":"az_q2c","alignEachItemPriceWithError":"az_r2c","unitPrice":"az_s2c","cartClass":"az_t2c","mxCart":"az_u2c","quantityAvailableError":"az_v2c"};